import styled from "styled-components"

const TimeLineStyle = styled.div`
    .events_data_container{
        display: flex;
        flex-direction: column;
        text-align: justify;
    }
    .events_header_section{
        font-weight: 700;
        padding: 16px 6px;
        border-bottom: 1px solid rgb(158, 165, 169);
        background-color: rgb(245, 245, 246);
    }
    .events_data_box_container{
        text-align: justify;
    }
    .events_data_box{
        padding: 2px 6px;
        display: flex;
        align-items: center;
        gap: 10px;

        &:hover{
            background: rgba(116, 176, 234, 0.25);
        }
    }
    .events_data_box:nth-child(even) {
        background-color: rgb(245, 245, 246);
        &:hover{
            background: rgba(116, 176, 234, 0.25);
        }
    }
    .creation-date{
        color: rgb(92, 100, 104);
        font-size: 12px;
        margin-bottom: 4px;
    }

    .event_name{
        font-size: 0.889rem;
        font-weight: 400;
        margin-top: 6px;
    }
    .event-backward-img-box{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        width: 32px;
        border-radius: 5px;
        background: rgba(116, 176, 234, 0.25);
        cursor: pointer;
    }
    .event-backward-img{
        rotate: 270deg;
        font-size: 20px;
        color: rgb(27, 104, 179);
    }
    .timeLine-filter-section{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        align-items: end;
    }
    .timeline_filter_input_label{   
        margin-bottom: 5px;
        font-size: 0.889rem;
        font-weight: 700;
        display: block;
    }
    .timeline_filter_input{
        width: 100%;
        height: 35px;
        text-align: justify;
        
    }
    .reset_filters{
        display: flex;
        margin: 0;
        align-items: center;
        // margin-top: 20px;
        justify-content: center;
        color: rgb(27, 104, 179);
        font-size: 0.889rem;
        cursor: pointer;
    }
    .input_reset_button{
        border: none;
        color: #2D53DA;
    }
`;

export default TimeLineStyle;